// import PropTypes from '@utils/prop-types'
import styles from './TextArea.scss'

const TextArea = ({ setValue, value }) => (
  <div className={styles.base}>
    <textarea onChange={(e) => setValue(e.target.value)} value={value} />
  </div>
)

TextArea.defaultProps = {}
TextArea.propTypes = {}

export default TextArea
